export default __webpack_public_path__ + "static/media/hamburger.5ed891a9.svg";